import { parseInt as parseConfigInt } from './parse-int.function';

/**
 * Parse a string to a positive integer, with a fallback if parsing fails or the value is not positive.
 * @param value The string value to parse.
 * @param fallback The fallback number if parsing fails or the parsed value is not positive.
 * @returns The parsed positive integer or the fallback.
 *
 * @example
 * parsePositiveInt("42", 10); // returns 42
 * parsePositiveInt("0", 10); // returns 10
 * parsePositiveInt("invalid", 10); // returns 10
 */
export function parsePositiveInt(
	value: string | undefined,
	fallback: number,
): number {
	const parsed = parseConfigInt(value, fallback);

	return parsed > 0 ? parsed : fallback;
}
